import React from 'react'

const HobiFlowerSvg = ({ width, focus }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 20.283 23.664'
    >
      <path
        id='Path_3176'
        data-name='Path 3176'
        d='M13.142,24.664A10.143,10.143,0,0,0,23.283,14.522,10.143,10.143,0,0,0,13.142,24.664ZM5.93,11.423a2.82,2.82,0,0,0,4.417,2.321l-.023.214a2.817,2.817,0,1,0,5.634,0l-.023-.214a2.777,2.777,0,0,0,1.6.5,2.811,2.811,0,0,0,1.206-5.353,2.813,2.813,0,1,0-2.806-4.857l.023-.214a2.817,2.817,0,1,0-5.634,0l.023.214a2.777,2.777,0,0,0-1.6-.5A2.811,2.811,0,0,0,7.541,8.888,2.807,2.807,0,0,0,5.93,11.423Zm7.212-5.353a2.817,2.817,0,1,1-2.817,2.817A2.818,2.818,0,0,1,13.142,6.071ZM3,14.522A10.143,10.143,0,0,0,13.142,24.664,10.143,10.143,0,0,0,3,14.522Z'
        transform='translate(-3 -1)'
        fill={!focus ? '#205c42' : '#fff'}
      />
    </svg>
  )
}

export default HobiFlowerSvg
